import { hookstate } from "@hookstate/core";
import { devtools } from "@hookstate/devtools";
import { AxiosError } from "axios";
import { AccessData } from "../screens/reader/types";
import { Comic, Release, Fragment, Page, BlogCommentEntity } from "../types";

export type ReaderDataState = {
  accessData?: AccessData;
  comicData?: Comic;
  comicReleasesData?: Release[];
  releaseData?: Release;
  releaseFragmentsData?: Fragment[];
  releaseAnnotationsData?: [];
  releasePagesData?: Page[];
  relatedReleasesData?: Release[];
  releaseCommentsData?: BlogCommentEntity[];
  loaded?: boolean;
  responseError?: AxiosError;
};

export const readerDataStore = hookstate<ReaderDataState>(
  {},
  devtools({ key: "reader" }),
);
